import React from 'react';
// Firebase auth functions
import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from 'firebase/auth';
// Firebase auth instance
import { auth } from 'lib/firebase';
import { useObject, useObjectVal } from 'react-firebase-hooks/database';
import { ref } from 'firebase/database';
import { database } from 'lib/firebase';
// Google oauth provider
const provider = new GoogleAuthProvider();
// Contexts
export const AuthContext = React.createContext(null);

export const ContextProvider = (props) => {
  // States to check auth status
  const [isSignedIn, setIsSignedIn] = React.useState(false);
  // False until Firebase reports the persisted session for the first time, so
  // layouts don't redirect to /auth (and lose the current route) on page refresh.
  const [isAuthReady, setIsAuthReady] = React.useState(false);
  const [authUser, setAuthUser] = React.useState(null);
  const [client, loading, error] = useObjectVal(ref(database, `user/${authUser?.uid}`));
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    // Listener updates auth status when detects change
    const unsubscribe = onAuthStateChanged(auth, (_user) => {
      if (_user) {
        setIsSignedIn(true);
        setAuthUser(_user);
      } else {
        setIsSignedIn(false);
        setAuthUser(null);
      }
      setIsAuthReady(true);
    });
    return unsubscribe;
  }, []);
  React.useEffect(() => {
    if (!user || client?.clientId !== user?.clientId) {
      setUser(client)
    }
  }, [client]);
  // Functions handling auth
  const signIn = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      return;
    } catch (err) {
      console.log(err.message);
      return err.message;
    }
  };
  const signUp = async (email, password) => {
    try {
      // await createUserWithEmailAndPassword(auth, email, password);
      return;
    } catch (err) {
      console.log(err.message);
      return err.message;
    }
  };
  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
    } catch (err) {
      console.log(err.message);
    }
  };
  const googleSignIn = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      console.log(err.message);
    }
  };
  // Context provider
  return (
    <AuthContext.Provider
      value={{
        isSignedIn,
        isAuthReady,
        // authUser,
        user,
        signIn,
        signUp,
        signOut,
        googleSignIn,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
